import React from 'react'
import { Section } from './section'
import { groupBy } from '../../utils'

export const APIReference = ({ nodes }) => {
  const entries = React.useMemo(() => groupBy(nodes, 'group'), [nodes])
  return (
    <>
      {Object.entries(entries).map(([groupName, sections], i) => (
        <React.Fragment key={groupName}>
          <h1>{groupName}</h1>
          <article>
            {sections.map(section => (
              <Section key={section.id} section={section} groupIndex={i + 1} />
            ))}
          </article>
        </React.Fragment>
      ))}
    </>
  )
}
